module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "research_group_container",
    style: ({
      'height': _vm.boxHeight
    })
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("订单详情")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.order),
      expression: "order"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status === 1),
      expression: "status===1"
    }],
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "group_2"
  }, [_c('span', {
    staticClass: "info",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("下单成员：" + _vm._s(_vm.order.orderPerson))]), _vm._v(" "), _c('span', {
    staticClass: "price",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("单笔订单限额：\n        "), (_vm.memberInfo.approveThreshold !== undefined) ? _c('span', [_vm._v("￥" + _vm._s(_vm.splitMoney(_vm.memberInfo.approveThreshold)))]) : _c('span', [_vm._v("无")])])]), _vm._v(" "), _c('div', {
    staticClass: "container_2"
  }, [_c('div', {
    staticClass: "priceWrap"
  }, [_c('span', {
    staticClass: "info_2",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("本月累计消费 ：")]), _vm._v(" "), _c('span', {
    staticClass: "price_2",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("¥" + _vm._s(_vm.splitMoney(_vm.monthlyTotalApprovedAmount)))])]), _vm._v(" "), _c('span', {
    staticClass: "money",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("单月累计限额：\n        "), (_vm.memberInfo.monthlyLimit !== undefined) ? _c('span', [_vm._v("￥" + _vm._s(_vm.splitMoney(_vm.memberInfo.monthlyLimit)))]) : _c('span', [_vm._v("无")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    style: ({
      'margin-top': _vm.orderAddress
    })
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.order.expressAddress !== '' && _vm.order.expressAddress !== undefined),
      expression: "order.expressAddress!==''&&order.expressAddress!==undefined"
    }],
    staticClass: "submain"
  }, [_c('div', {
    staticStyle: {
      "line-height": "15.2vw",
      "margin-left": "4vw"
    }
  }, [_c('svg', {
    attrs: {
      "width": "12px",
      "height": "17px",
      "viewBox": "0 0 12 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("形状")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "执行中订单详情",
      "transform": "translate(-25.000000, -118.000000)",
      "fill": "#5878FA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "地点",
      "transform": "translate(25.000000, 118.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.99998382,0 C2.68650826,0 0,2.76794957 0,6.18183182 C0,11.2045379 5.99998382,17 5.99998382,17 C5.99998382,17 12,11.2045712 12,6.18183182 C12,2.76794957 9.31350792,0 5.99998382,0 Z M5.99998382,9.27270606 C4.34252624,9.27270606 3,7.88874794 3,6.18181515 C3,4.47488236 4.34251007,3.09090758 5.99998382,3.09090758 C7.65676205,3.09090758 8.99998382,4.47488236 8.99998382,6.18181515 C8.99998382,7.88873128 7.6567297,9.27270606 5.99998382,9.27270606 Z",
      "id": "形状"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "address_area"
  }, [_c('span', {
    staticClass: "phonePrev",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.order.expressAddress))]), _vm._v(" "), _c('span', {
    staticClass: "luWei",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.order.expressName) + "  " + _vm._s(_vm.order.expressMobile))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "block_4"
  }, [_c('span', {
    staticClass: "orderNumber",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("订单编号：" + _vm._s(_vm.order.orderNo))]), _vm._v(" "), _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag",
    attrs: {
      "id": "tag-copy",
      "data-clipboard-text": _vm.order.orderNo,
      "lines": undefined
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制")])])]), _vm._v(" "), _c('div', {
    staticClass: "div"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "4vw",
      "padding-right": "4vw",
      "width": "100%"
    }
  }, _vm._l((_vm.order.itemList), function(item, i) {
    return _c('div', {
      staticStyle: {
        "padding-top": "10px"
      }
    }, [(_vm.order.fromEmkt) ? _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "height": "52px"
      }
    }, [_c('div', {
      staticClass: "block-address"
    }, [(item.merchandiseIcon) ? _c('img', {
      staticClass: "largeIcon",
      attrs: {
        "src": _vm.baseurl + item.merchandiseIcon
      }
    }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
      staticClass: "largeIcon",
      attrs: {
        "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
      }
    }) : _c('img', {
      staticClass: "largeIcon",
      attrs: {
        "src": _vm.serviceUrl
      }
    }), _vm._v(" "), (item.categoryId) ? _c('div', {
      staticClass: "item-detail"
    }, [(item._titleList && item._titleList.length > 0) ? _c('span', {
      staticClass: "deep-text-color text-overflow-hidden",
      staticStyle: {
        "font-size": "12px"
      }
    }, _vm._l((item._titleList), function(title) {
      return _c('span', [(title.valueText && title.valueText !== '-1' && title.value !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))]), _vm._v(" ")]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (item._subTitleList && item._subTitleList.length > 0) ? _c('span', {
      staticClass: "light-text-color tiny-font text-overflow-hidden"
    }, _vm._l((item._subTitleList), function(subTitle, index) {
      return _c('span', [(index !== 0) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1') ? _c('span', [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()])
    }), 0) : _vm._e(), _vm._v(" "), (item._abstractList && item._abstractList.length > 0) ? _c('span', {
      staticClass: "light-text-color tiny-font text-overflow-hidden"
    }, _vm._l((item._abstractList), function(abstractTitle, index) {
      return _c('span', [(abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1') ? _c('span', [(abstractTitle.columnName === 'TVInfo' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))]), _vm._v(" ")]) : _vm._e()])
    }), 0) : _vm._e()]) : _c('div', {
      staticClass: "item-detail"
    }, [_c('span', {
      staticClass: "deep-text-color",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("\n                 " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color small-font"
    }, [_c('span', [_vm._v("\n                  " + _vm._s(_vm.stringSet(item.serviceItemDetail.productInfoList[0])) + "\n                ")])]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color small-font"
    }, [_c('span', [_vm._v("\n                   " + _vm._s(item.serviceItemDetail.productInfoList[1]) + "\n                 ")])])])]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color"
    }, [_vm._v("X " + _vm._s(item.quantity))])]) : (item.productType === _vm.emkt.PRODUCT_TYPE_TOOL) ? _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "height": "52px"
      }
    }, [_c('div', {
      staticClass: "block-address"
    }, [(item.merchandiseIcon) ? _c('img', {
      staticClass: "largeIcon",
      attrs: {
        "src": _vm.baseurl + item.merchandiseIcon
      }
    }) : (item.categoryId === 20 || item.categoryId === 10) ? _c('img', {
      staticClass: "largeIcon",
      attrs: {
        "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-detail"
    }, [_c('span', {
      staticClass: "deep-text-color text-overflow-hidden",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color tiny-font text-overflow-hidden"
    }, [_vm._v(_vm._s(item.TLNo) + " " + _vm._s(item.tag1PUBID) + " " + _vm._s(item.eu_RID))]), _vm._v(" "), (item.tax) ? _c('span', {
      staticClass: "light-text-color tiny-font text-overflow-hidden"
    }, [_vm._v(_vm._s(item.tax) + " "), (item.symbol) ? _c('span', [_vm._v(_vm._s(item.symbol))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('span', {
      staticClass: "light-text-color"
    }, [_vm._v("X " + _vm._s(item.quantity))])]) : ((item.productType !== _vm.emkt.PRODUCT_TYPE_TOOL) && (item.contractNoSrc === '' || item.contractNoSrc === undefined)) ? _c('div', {
      staticClass: "block-item",
      staticStyle: {
        "height": "80px"
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "item-detail"
    }, [_c('span', {
      staticClass: "deep-text-color",
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v(_vm._s(item.name))])])]) : _vm._e(), _vm._v(" "), (item.productType === '服务类') ? _c('div', {
      staticClass: "priceWrap_2"
    }, [(_vm.showProductDetailBtn(item) && item.name !== '实物返还' && _vm.isService) ? _c('div', {
      staticClass: "tagWrap_2",
      on: {
        "click": function($event) {
          return _vm.toProductInfo(item.orderId, item.serviceItemDetail.euId)
        }
      }
    }, [_c('span', {
      staticClass: "tag_2",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("产品详情")])]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.status === 2),
        expression: "status===2"
      }],
      class: [item.orderId !== undefined ? 'tagWrap_3' : 'tagWrap_2'],
      on: {
        "click": function($event) {
          return _vm.toProgress(item)
        }
      }
    }, [_c('span', {
      class: [item.orderId !== undefined ? 'tag_3' : 'tag_2']
    }, [_vm._v("进展查询")])]), _vm._v(" "), _c('span', {
      staticClass: "price_3",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("￥" + _vm._s(_vm.splitMoney(item.price)))])]) : _vm._e(), _vm._v(" "), (item.productType === '产品类') ? _c('div', {
      staticClass: "priceWrap_2"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.orderId !== undefined),
        expression: "item.orderId!==undefined"
      }],
      staticClass: "tagWrap_2",
      on: {
        "click": function($event) {
          return _vm.toProductInfo(item.orderId)
        }
      }
    }, [_c('span', {
      staticClass: "tag_2",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("产品详情")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.status === 2),
        expression: "status===2"
      }],
      class: [item.orderId !== undefined ? 'tagWrap_3' : 'tagWrap_2'],
      on: {
        "click": function($event) {
          return _vm.toProgress(item)
        }
      }
    }, [_c('span', {
      class: [item.orderId !== undefined ? 'tag_3' : 'tag_2']
    }, [_vm._v("进展查询")])]), _vm._v(" "), _c('span', {
      staticClass: "price_3",
      attrs: {
        "lines": undefined
      }
    }, [_vm._v("￥" + _vm._s(_vm.splitMoney(item.price)))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "split-line"
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "moneyWrap_2"
  }, [_c('span', {
    staticClass: "totalMerchandise",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("商品总额")]), _vm._v(" "), _c('span', {
    staticClass: "money_3",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("￥" + _vm._s(_vm.splitMoney(_vm.order.initPrice)))])]), _vm._v(" "), _c('div', {
    staticClass: "container_4"
  }, [_c('span', {
    staticClass: "discount",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("优惠折扣")]), _vm._v(" "), _c('span', {
    staticClass: "price_5",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("-￥" + _vm._s(_vm.discountPrice))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.order.expressPrice),
      expression: "order.expressPrice"
    }],
    staticClass: "moneyWrap_3"
  }, [_c('span', {
    staticClass: "freight",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("运费")]), _vm._v(" "), _c('span', {
    staticClass: "money_4",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("￥" + _vm._s(_vm.order.expressPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), _c('div', {
    staticClass: "group_5"
  }, [_c('span', {
    staticClass: "totalGoods",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("共" + _vm._s(_vm.itemListLength) + "件商品")]), _vm._v(" "), _c('div', {
    staticClass: "moneyWrap_4"
  }, [_c('span', {
    staticClass: "total",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("合计")]), _vm._v(" "), _c('span', {
    staticClass: "money_5",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("￥" + _vm._s(_vm.splitMoney(_vm.order.price)))])])])])]), _vm._v(" "), _c('div', {
    style: ({
      'padding-bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [_c('div', {
    staticClass: "row_area"
  }, [_c('div', {
    staticClass: "row0"
  }, [_c('span', {
    staticClass: "paymentMethod",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("支付方式")]), _vm._v(" "), _c('span', {
    staticClass: "info_4",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.displayChosenResearchGroup.researchGroupName) + "结算")])]), _vm._v(" "), _c('div', {
    staticClass: "row1"
  }, [_c('span', {
    staticClass: "orderTime",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("下单时间")]), _vm._v(" "), _c('span', {
    staticClass: "word",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.order.orderTime))])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status === 1),
      expression: "status===1"
    }],
    staticClass: "block_6"
  }, [(_vm.order.fromEmkt) ? _c('div', {
    staticClass: "tagWrap_5",
    on: {
      "click": function($event) {
        return _vm.toggleResearchGroupDisagreeBox()
      }
    }
  }, [_c('span', {
    staticClass: "tag_5",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("不同意")])]) : _vm._e(), _vm._v(" "), (_vm.order.fromEmkt) ? _c('div', {
    staticClass: "tagWrap_6",
    on: {
      "click": function($event) {
        return _vm.agree()
      }
    }
  }, [_c('span', {
    staticClass: "tag_6",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("同意")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "customerService",
    attrs: {
      "lines": undefined
    },
    on: {
      "click": _vm.goMessage
    }
  }, [_vm._v("客服")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "7vw",
      "top": "0.67vh"
    },
    on: {
      "click": _vm.goMessage
    }
  }, [_c('svg', {
    attrs: {
      "width": "20px",
      "height": "23px",
      "viewBox": "0 0 20 23",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("服务评价-客服")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "课题组",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "待审批-订单详情",
      "transform": "translate(-26.000000, -862.000000)",
      "fill": "#4191EA",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组-6",
      "transform": "translate(0.000000, 849.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "编组",
      "transform": "translate(26.000000, 13.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "服务评价-客服",
      "transform": "translate(0.000000, 0.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.0783731,12.6660875 L19.0783731,12.0399707 C19.1274803,9.1794763 18.2877472,6.7732235 16.6328345,5.0667483 C15.8422086,4.25156878 14.8895289,3.63772878 13.7846169,3.21049614 C13.607831,1.66853006 11.9529184,0.450671497 9.93461243,0.450671497 C7.91630651,0.450671497 6.24666171,1.6660747 6.08460795,3.21049614 C4.97969595,3.63772878 4.02701627,4.25156878 3.23639035,5.0667483 C1.58147771,6.7732235 0.739289234,9.1671995 0.790851794,12.0276939 L0.790851794,12.7937662 C0.363619154,13.2332757 0.0247794743,13.8839461 0.277681554,14.8120721 C0.466744274,15.5020283 0.967637714,16.0029217 1.58147771,16.2288149 C1.89576379,16.4301544 2.25915707,16.5431009 2.65938075,16.5431009 C3.45000667,20.0051585 6.29576891,22.3623041 10.0230054,22.3623041 C13.7477865,22.3623041 16.5960041,20.0051585 17.38663,16.5308241 C17.4111836,16.5308241 17.4357372,16.5431009 17.4627462,16.5431009 C17.9513628,16.5431009 18.4031491,16.366315 18.7665424,16.0790379 C19.2306054,15.8163144 19.5939987,15.3645281 19.7437756,14.7997953 C20.0064992,13.7930977 19.5669897,13.1031416 19.0783731,12.6660875 Z M16.895558,14.5591701 C16.895558,15.0232331 16.8587276,15.4627425 16.7948883,15.8875198 C15.5794851,17.8444417 13.5710006,19.1236843 11.0763548,19.3986846 C10.8872921,19.1482379 10.511622,18.9837288 10.0721126,18.9837288 C9.44599579,18.9837288 8.94264699,19.3225685 8.94264699,19.7498011 C8.94264699,20.1647569 9.44354043,20.5158734 10.0721126,20.5158734 C10.6368454,20.5158734 11.0886316,20.2408731 11.1893014,19.8750245 C11.9922041,19.7866315 12.7582764,19.5877473 13.485063,19.2980149 C14.5138588,18.883059 15.4174313,18.269219 16.1810483,17.4908699 C16.3062716,17.3656465 16.4192182,17.2404232 16.5321648,17.102923 C15.6285923,19.8774798 13.2076073,21.6576158 10.0598358,21.6576158 L10.0352822,21.6576158 C5.98393819,21.6576158 3.16272955,18.7357374 3.16272955,14.5591701 L3.15045275,14.1589464 C3.15045275,13.9821605 3.17500635,13.5058206 3.19955995,13.0540344 C4.88148155,12.4401944 6.39889403,10.0928702 7.01273403,9.01496718 C7.57746683,9.7810395 8.86898619,11.2591662 10.8504617,12.0252385 C11.5895251,12.3125157 12.3433206,12.464748 13.082384,12.6268017 C14.5506892,12.9410878 15.9428784,13.2406417 16.8832812,14.4707771 L16.9201116,14.5076075 L16.895558,14.5591701 L16.895558,14.5591701 Z",
      "id": "形状"
    }
  })])])])])])])])]), _vm._v(" "), _c('footer-placeholder')], 1), _vm._v(" "), (_vm.showResearchGroupDisagreeBox) ? _c('ResearchGroupDisagreeBox', {
    on: {
      "toggleShow": _vm.toggleResearchGroupDisagreeBox,
      "confirm": _vm.disagree
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabbarserviceselWrap"
  }, [_c('img', {
    staticClass: "iconTest",
    attrs: {
      "src": "static/img/service_product.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-613bf14b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupProgress/OrderDetailInfo.vue
// module id = 1659
// module chunks = 8